import { render, staticRenderFns } from "./DocSwagger.vue?vue&type=template&id=34f81b1c&"
import script from "./DocSwagger.vue?vue&type=script&lang=js&"
export * from "./DocSwagger.vue?vue&type=script&lang=js&"
import style0 from "./DocSwagger.vue?vue&type=style&index=0&id=34f81b1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports